import BrowserStorage from ".";

const browserLocalStorage = new BrowserStorage(window.localStorage);

export default browserLocalStorage;